// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UnitOfMeasure } from "./UnitOfMeasure";
import {
  UnitOfMeasureFromJSON,
  UnitOfMeasureFromJSONTyped,
  UnitOfMeasureToJSON,
  UnitOfMeasureToJSONTyped,
} from "./UnitOfMeasure";
import type { PhysicalQuantity } from "./PhysicalQuantity";
import {
  PhysicalQuantityFromJSON,
  PhysicalQuantityFromJSONTyped,
  PhysicalQuantityToJSON,
  PhysicalQuantityToJSONTyped,
} from "./PhysicalQuantity";

/**
 *
 * @export
 * @interface RasterUserSuppliedMeta
 */
export interface RasterUserSuppliedMeta {
  /**
   *
   */
  physicalQuantity?: PhysicalQuantity | null;
  /**
   * Unit of measure for the raster values
   */
  unit?: UnitOfMeasure | null;
  /**
   *
   */
  styleId?: string | null;
  /**
   *
   */
  styleMinMax?: Array<any> | null;
}

/**
 * Check if a given object implements the RasterUserSuppliedMeta interface.
 */
export function instanceOfRasterUserSuppliedMeta(value: object): value is RasterUserSuppliedMeta {
  return true;
}

export function RasterUserSuppliedMetaFromJSON(json: any): RasterUserSuppliedMeta {
  return RasterUserSuppliedMetaFromJSONTyped(json, false);
}

export function RasterUserSuppliedMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterUserSuppliedMeta {
  if (json == null) {
    return json;
  }
  return {
    physicalQuantity:
      json["physical_quantity"] === undefined
        ? undefined
        : json["physical_quantity"] === null
        ? null
        : PhysicalQuantityFromJSON(json["physical_quantity"]),
    unit:
      json["unit"] === undefined
        ? undefined
        : json["unit"] === null
        ? null
        : UnitOfMeasureFromJSON(json["unit"]),
    styleId:
      json["style_id"] === undefined
        ? undefined
        : json["style_id"] === null
        ? null
        : json["style_id"],
    styleMinMax:
      json["style_min_max"] === undefined
        ? undefined
        : json["style_min_max"] === null
        ? null
        : json["style_min_max"],
  };
}

export function RasterUserSuppliedMetaToJSON(json: any): RasterUserSuppliedMeta {
  return RasterUserSuppliedMetaToJSONTyped(json, false);
}

export function RasterUserSuppliedMetaToJSONTyped(
  value?: RasterUserSuppliedMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    physical_quantity: PhysicalQuantityToJSON(value["physicalQuantity"]),
    unit: UnitOfMeasureToJSON(value["unit"]),
    style_id: value["styleId"],
    style_min_max: value["styleMinMax"],
  };
}
